import "../styles/footer.css";
import Log from "../assets/logo_dark.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Ambrum from "../assets/ambrum.webp";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
const Footer = () => (
  <footer className="footer p-0">
    <div className="container footer-main p-3 px-5 p-md-5">
      <div className="footer-section logo-section">
        <div className="col-12 col-md-7">
          <img src={Log} alt="Brief Logo" className="footer-logo" />
        <div className="social-icons">
          <a href="#">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="#">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
        </div>
      </div>

      <div className="footer-section contact-section">
        <h3>Get In Touch</h3>
      <div className="mt-5">
          <p className="plain_textf">
          <FontAwesomeIcon icon={faMapMarkerAlt} /> Brief, Kalawila Village,
          Beruwala, 12070.
        </p>
        <p className="plain_textf d-flex">

           <FontAwesomeIcon icon={faPhone} className="my-auto"/>
           <div>
            +94 (0) 11 406 3290
          <br />
          +94 (0) 77 406 0363
           </div>
        </p>
        <p className="plain_textf">
          <FontAwesomeIcon icon={faEnvelope} /> info@briefgarden.com
        </p>
      </div>
      </div>

      <div className="footer-section sitemap-section">
        <h3>Site Map</h3>
        <ul className="mt-5 bottom_nav">
          <li>
            <a href="/">HOME</a>
          </li>
          <li>
            <a href="/packages">PACKAGES</a>
          </li>
          <li>
            <a href="/gallery">GALLERY</a>
          </li>
          <li>
            <a href="https://www.google.com/maps?ll=6.45702,80.037736&z=17&t=h&hl=en&gl=LK&mapclient=embed&cid=16038840211384883595">MAP</a>
          </li>
          <li>
            <a href="/shop">SHOP</a>
          </li>
          <li>
            <a href="/about">ABOUT</a>
          </li>
          <li>
            <a href="/contact">CONTACT</a>
          </li>
          <li>
            <a href="/cart">CART</a>
          </li>
        </ul>
      </div>
    </div>

    <hr />

    <div className="footer-bottom">
     
      <div className="col m-auto d-flex">
        <p className="plain_text  m-0">
        Powered by
       
      </p>
       <div>
        <img src={Ambrum} alt="Ambrum" className="ambrum-logo w-100 " />
       </div>
      </div>
    </div>
  </footer>
);
export default Footer;
